// extracted by mini-css-extract-plugin
export var code_color_wrapper = "colors-module--code_color_wrapper--4df23";
export var colors_wrapper = "colors-module--colors_wrapper--bc632";
export var mini_color_wrapper = "colors-module--mini_color_wrapper--fcb2e";